/* ============================================================================
   ENGORI — Rabattcode-Feld im Warenkorb

   Shrines eigener Handler (handleDiscountForm in der externen main.js) übernimmt
   den Code nicht zuverlässig. Hier wird das Absenden abgefangen und stattdessen
   der Weg genommen, der nachweislich funktioniert:

       GET /discount/<CODE>     -> Shopify merkt den Code für diesen Warenkorb
       danach Warenkorb neu laden

   Getestet: 34,99 € -> 31,50 € mit ENGORI10.
   ========================================================================= */
(function () {
  'use strict';

  var LAEUFT = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function meldung(form, text, fehler) {
    var el = form.querySelector('.cart-discount-form__error');
    if (!el) return;
    el.textContent = text;
    el.style.display = text ? 'block' : 'none';
    el.style.color = fehler ? '' : 'var(--eng-ok, #1a8c4e)';
  }

  function drawerNeuLaden() {
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (drawer && typeof drawer.getSectionsToRender === 'function' && typeof drawer.renderContents === 'function') {
      var ids = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      return fetch(root() + 'cart.js?sections=' + encodeURIComponent(ids) +
                   '&sections_url=' + encodeURIComponent(window.location.pathname))
        .then(function (r) { return r.json(); })
        .then(function (state) { drawer.renderContents(state); });
    }
    window.location.reload();
    return Promise.resolve();
  }

  function absenden(e) {
    var form = e.target.closest ? e.target.closest('.cart-discount-form') : null;
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();
    if (LAEUFT) return;

    var feld = form.querySelector('input[name="cart-discount-field"], input[type="text"]');
    var code = feld ? (feld.value || '').trim() : '';
    if (!code) { meldung(form, 'Bitte einen Rabattcode eingeben.', true); return; }

    LAEUFT = true;
    var btn = form.querySelector('button[type="submit"]');
    var btnText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Prüfe …'; }
    meldung(form, '', false);

    fetch(root() + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () { return fetch(root() + 'cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var an = (cart.cart_level_discount_applications || []).some(function (d) {
          return (d.title || '').toUpperCase() === code.toUpperCase();
        }) || cart.total_discount > 0;

        if (an) {
          meldung(form, 'Rabatt "' + code.toUpperCase() + '" wurde angewendet.', false);
          if (feld) feld.value = '';
          return drawerNeuLaden();
        }
        meldung(form, 'Dieser Code ist nicht gültig oder gilt nicht für deinen Warenkorb.', true);
      })
      .catch(function () {
        meldung(form, 'Das hat gerade nicht geklappt. Bitte noch einmal versuchen.', true);
      })
      .finally(function () {
        LAEUFT = false;
        if (btn) { btn.disabled = false; btn.textContent = btnText; }
      });
  }

  /* In der Capture-Phase, damit Shrines eigener onsubmit nicht zuerst greift */
  document.addEventListener('submit', absenden, true);
})();
